<template>
  <div>
    <h1 class="text-2xl font-bold mb-4">Users</h1>
    <p class="mb-6">Manage users here.</p>
    <div v-if="loading" class="text-center text-gray-500">Loading users...</div>
    <div v-else-if="error" class="text-center text-red-500">{{ error }}</div>
    <div v-else-if="users.length === 0" class="text-center text-gray-500">No users found.</div>
    <div v-else class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
        <thead>
          <tr class="bg-gray-100">
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">Name</th>
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">Email</th>
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">Contact</th>
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">City</th>
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">District</th>
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">State</th>
            <th class="px-4 py-2 text-center text-sm font-medium text-gray-700">Profile</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id" class="border-t border-gray-200">
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.name }}</td>
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.email }}</td>
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.contact }}</td>
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.city || 'N/A' }}</td>
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.district || 'N/A' }}</td>
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.state || 'N/A' }}</td>
            <td class="px-4 py-2 text-sm text-gray-600">{{ user.profile }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

// State for users, loading, and error
const users = ref([]);
const loading = ref(false);
const error = ref(null);

// Fetch users from the backend
const fetchUsers = async () => {
  loading.value = true;
  error.value = null;
  try {
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/users`);
    if (!response.ok) {
      throw new Error('Failed to fetch users');
    }
    const data = await response.json();
    users.value = data;
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};

// Fetch users when component is mounted
onMounted(fetchUsers);
</script>